import { render, staticRenderFns } from "./products-maintenance.vue?vue&type=template&id=681f6d82&"
import script from "./products-maintenance.vue?vue&type=script&lang=js&"
export * from "./products-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports